var _defs, _rect, _polygon, _g, _polygon2, _polygon3, _g2, _g3, _polygon4, _polygon5, _polygon6, _g4, _polygon7, _polygon8, _path, _path2, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationCarton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_6",
    "data-name": "Calque 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_389);}.cls-3{fill:#6d6d6d;opacity:0.53;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_386);}.cls-6,.cls-7{fill:#444;}.cls-7{opacity:0.44;}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_8);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_8-2);}.cls-10{fill:#d48445;}.cls-11{fill:#3a1809;}.cls-12{clip-path:url(#clip-path-2);}.cls-13{fill:#ecc09b;}.cls-14{fill:#221216;}.cls-14,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24{opacity:0.38;}.cls-15,.cls-26{opacity:0.13;}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_6);}.cls-16,.cls-17{fill:#c59370;}.cls-17{opacity:0.54;}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_8-3);}.cls-19{fill:#ad7955;}.cls-20{fill:#300f00;}.cls-21{fill:#2e1203;}.cls-22{fill:#1e0500;}.cls-23{fill:#613e1e;}.cls-24,.cls-25{fill:#b99471;}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_6-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_389",
    x1: 1500,
    y1: 2431,
    x2: 1500,
    y2: 3001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2796.18 0 2787 0 2601.18 0 2556 0 2495.18 0 2370.18 0 2361 0 2264.18 0 2255 0 2130 0 2069.18 0 2024 0 1838.18 0 1829 0 1750.18 0 1598 0 1519.18 0 1510 0 1324.18 0 1279 0 1093.18 0 1084 0 897.18 0 853 0 666.18 0 657 0 471.18 0 426 0 240.18 0 231 0 0 0 0 2438.11 52.13 2438.11 57 2450 96 2450 101.02 2438.11 157 2438 163 2450 202 2450 207.96 2438 235.36 2438 235.59 2438 235.82 2438 263.22 2438 269.18 2450 308.18 2450 314.18 2438 370.16 2438.11 375.18 2450 414.18 2450 419.05 2438.11 426 2438.11 471.18 2438.11 478.13 2438.11 483 2450 522 2450 527.02 2438.11 583 2438 589 2450 628 2450 633.96 2438 661.36 2438 661.59 2438 661.83 2438 689.22 2438 695.18 2450 734.18 2450 740.18 2438 796.16 2438.11 801.18 2450 840.18 2450 845.05 2438.11 853 2438.11 897.18 2438.11 905.13 2438.11 910 2450 949 2450 954.02 2438.11 1010 2438 1016 2450 1055 2450 1060.96 2438 1088.36 2438 1088.59 2438 1088.83 2438 1116.22 2438 1122.18 2450 1161.18 2450 1167.18 2438 1223.16 2438.11 1228.18 2450 1267.18 2450 1272.05 2438.11 1279 2438.11 1324.18 2438.11 1331.13 2438.11 1336 2450 1375 2450 1380.02 2438.11 1436 2438 1442 2450 1481 2450 1486.96 2438 1514.36 2438 1514.59 2438 1514.83 2438 1542.22 2438 1548.18 2450 1587.18 2450 1593.18 2438 1598 2438.01 1598 2438.11 1649.16 2438.11 1654.18 2450 1655 2450 1693.18 2450 1694 2450 1699.02 2438.11 1750.18 2438.11 1750.18 2438.01 1755 2438 1761 2450 1800 2450 1805.96 2438 1833.36 2438 1833.59 2438 1833.83 2438 1861.22 2438 1867.18 2450 1906.18 2450 1912.18 2438 1968.16 2438.11 1973.18 2450 2012.18 2450 2017.05 2438.11 2024 2438.11 2069.18 2438.11 2076.13 2438.11 2081 2450 2120 2450 2125.02 2438.11 2130 2438.1 2130 2438.11 2181.05 2438.11 2187 2450 2226 2450 2231.91 2438.11 2285.99 2438 2287 2438 2293 2450 2293.18 2450 2332 2450 2332.18 2450 2338.18 2438 2339.2 2438 2393.27 2438.11 2399.18 2450 2438.18 2450 2444.13 2438.11 2495.18 2438.11 2495.18 2438.1 2500.16 2438.11 2505.18 2450 2544.18 2450 2549.05 2438.11 2556 2438.11 2601.18 2438.11 2608.13 2438.11 2613 2450 2652 2450 2657.02 2438.11 2713 2438 2719 2450 2758 2450 2763.96 2438 2791.36 2438 2791.59 2438 2791.82 2438 2819.22 2438 2825.18 2450 2864.18 2450 2870.18 2438 2926.16 2438.11 2931.18 2450 2970.18 2450 2975.05 2438.11 3000 2438.11 3000 0 2796.18 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_386",
    x1: 1500,
    y1: 1,
    x2: 1500,
    y2: 2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8",
    x1: 936.5,
    y1: 2507,
    x2: 936.5,
    y2: 2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d48445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b2319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-2",
    x1: 1903.82,
    y1: 2658.44,
    x2: 1903.82,
    y2: 2248.72,
    gradientTransform: "matrix(-1, 0, 0, 1, 4143.78, 1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2694.31,2500.2l5.13-188.72-41.06-71.88c-.52-2.37-.72-4.59,0-6.38V2048.93c-1.37-2.87-1.8-5.58,0-7.89V1862.19L2593,1796.33H2167v29.85l-346.69,1.19,5.58,602.73,69.82,70.1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6",
    x1: 2514.83,
    y1: 1908.29,
    x2: 2514.83,
    y2: 1796.33,
    gradientTransform: "matrix(-1, 0, 0, 1, 4755.1, 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edc19d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b2319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-3",
    x1: 2795.5,
    y1: 2658.44,
    x2: 2795.5,
    y2: 2357,
    gradientTransform: "matrix(-1, 0, 0, 1, 4143.78, 1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-2",
    x1: 2905.77,
    y1: 1531.23,
    x2: 2905.77,
    y2: 1452.39,
    gradientTransform: "matrix(-1, 0, 0, 1, 4477.12, 1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "carton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 2431,
    width: 3000,
    height: 570
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "919 2507 1013 2658 2699 2658 2524 2418 908.64 2403.78 919 2507"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2796.18 1 2787 1 2601.18 1 2556 1 2495.18 1 2370.18 1 2361 1 2264.18 1 2255 1 2130 1 2069.18 1 2024 1 1838.18 1 1829 1 1750.18 1 1598 1 1519.18 1 1510 1 1324.18 1 1279 1 1093.18 1 1084 1 897.18 1 853 1 666.18 1 657 1 471.18 1 426 1 240.18 1 231 1 0 1 0 2439.11 52.13 2439.11 57 2451 96 2451 101.02 2439.11 157 2439 163 2451 202 2451 207.96 2439 235.36 2439 235.59 2439 235.82 2439 263.22 2439 269.18 2451 308.18 2451 314.18 2439 370.16 2439.11 375.18 2451 414.18 2451 419.05 2439.11 426 2439.11 471.18 2439.11 478.13 2439.11 483 2451 522 2451 527.02 2439.11 583 2439 589 2451 628 2451 633.96 2439 661.36 2439 661.59 2439 661.83 2439 689.22 2439 695.18 2451 734.18 2451 740.18 2439 796.16 2439.11 801.18 2451 840.18 2451 845.05 2439.11 853 2439.11 897.18 2439.11 905.13 2439.11 910 2451 949 2451 954.02 2439.11 1010 2439 1016 2451 1055 2451 1060.96 2439 1088.36 2439 1088.59 2439 1088.83 2439 1116.22 2439 1122.18 2451 1161.18 2451 1167.18 2439 1223.16 2439.11 1228.18 2451 1267.18 2451 1272.05 2439.11 1279 2439.11 1324.18 2439.11 1331.13 2439.11 1336 2451 1375 2451 1380.02 2439.11 1436 2439 1442 2451 1481 2451 1486.96 2439 1514.36 2439 1514.59 2439 1514.83 2439 1542.22 2439 1548.18 2451 1587.18 2451 1593.18 2439 1598 2439.01 1598 2439.11 1649.16 2439.11 1654.18 2451 1655 2451 1693.18 2451 1694 2451 1699.02 2439.11 1750.18 2439.11 1750.18 2439.01 1755 2439 1761 2451 1800 2451 1805.96 2439 1833.36 2439 1833.59 2439 1833.83 2439 1861.22 2439 1867.18 2451 1906.18 2451 1912.18 2439 1968.16 2439.11 1973.18 2451 2012.18 2451 2017.05 2439.11 2024 2439.11 2069.18 2439.11 2076.13 2439.11 2081 2451 2120 2451 2125.02 2439.11 2130 2439.1 2130 2439.11 2181.05 2439.11 2187 2451 2226 2451 2231.91 2439.11 2285.99 2439 2287 2439 2293 2451 2293.18 2451 2332 2451 2332.18 2451 2338.18 2439 2339.2 2439 2393.27 2439.11 2399.18 2451 2438.18 2451 2444.13 2439.11 2495.18 2439.11 2495.18 2439.1 2500.16 2439.11 2505.18 2451 2544.18 2451 2549.05 2439.11 2556 2439.11 2601.18 2439.11 2608.13 2439.11 2613 2451 2652 2451 2657.02 2439.11 2713 2439 2719 2451 2758 2451 2763.96 2439 2791.36 2439 2791.59 2439 2791.82 2439 2819.22 2439 2825.18 2451 2864.18 2451 2870.18 2439 2926.16 2439.11 2931.18 2451 2970.18 2451 2975.05 2439.11 3000 2439.11 3000 1 2796.18 1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 57,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 163,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 269,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 377,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 483,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 589,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 695,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 803,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 909,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1015,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1121,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1229,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1335,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1441,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1547,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1655,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1761,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1867,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1973,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2081,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2187,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2293,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2399,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2507,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2613,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2719,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2825,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2931,
    y: 1,
    width: 39,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 52,
    y: 1,
    width: 49,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 157,
    y: 1,
    width: 51,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 263,
    y: 1,
    width: 51,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 370,
    y: 1,
    width: 49,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 478,
    y: 1,
    width: 49,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 583,
    y: 1,
    width: 51,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 689,
    y: 1,
    width: 51,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 796,
    y: 1,
    width: 49,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2926,
    y: 1,
    width: 49,
    height: 2450
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2819,
    width: 51,
    height: 2452
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2713,
    width: 51,
    height: 2452
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "954 2473.87 919 2431 919 2507 954 2507 954 2473.87"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "2707 2506.45 2690.66 2493.04 1862.44 2249.72 1772.93 2250.34 1786.82 2417.15 1868.32 2507.68 1873.32 2611.67 1902.51 2659.44 1897.33 2502.56 2166.18 2560.4 2230.5 2657.18 2348.24 2539.62 2523.51 2560.26 2601.78 2659.44 2707 2506.45"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2701.68 2658.08 2705.38 2505.09 1895.71 2501.2 1900.89 2658.08 2005.26 2658.08 2002.67 2558.25 2231.5 2559.55 2231.5 2658.08 2370.23 2658.08 2374.77 2558.9 2604.25 2558.9 2602.96 2658.08 2701.68 2658.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2524.68,
    y: 2514.58,
    width: 41.76,
    height: 15.82,
    transform: "translate(5091.12 5045.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2379.15,
    y: 2514.58,
    width: 41.76,
    height: 15.82,
    transform: "translate(4800.06 5045.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2188.07,
    y: 2514.58,
    width: 41.76,
    height: 15.82,
    transform: "translate(4417.9 5045.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2042.54,
    y: 2514.58,
    width: 41.76,
    height: 15.82,
    transform: "translate(4126.85 5045.98) rotate(-180)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2694.31,2500.2l5.13-188.72-41.06-71.88c-.52-2.37-.72-4.59,0-6.38V2048.93c-1.37-2.87-1.8-5.58,0-7.89V1862.19L2593,1796.33l-425.95.34v29.51l-346.69,1.19,5.58,602.73,69.82,70.1Z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "2300.54 2501.2 2300.54 2304.18 2292.76 2286.83 2292.76 2293.84 1895.71 2292.56 1895.71 2300.84 2294.04 2301.48 2292.76 2501.2 2300.54 2501.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2293.55,
    y: 2234.22,
    width: 364.84,
    height: 6.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "2658.38 2049.93 2293.55 2052.56 2293.55 2042.04 2658.38 2042.04 2658.38 2049.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "2285.18 2102.14 2285.18 2097.07 1895.71 2094.12 1895.71 2102.14 2285.18 2102.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "2660.23 1864.64 2255.62 1864.64 2294.68 1909.29 1890.07 1900.92 1820.31 1828.37 2206 1826 2167 1798 2592.95 1797.33 2660.23 1864.64"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1895.65 2500.86 1904.02 1909.29 1820.31 1828.37 1825.89 2431.1 1895.65 2500.86"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "2658.38 1863.19 2255.62 1864.64 2294.65 1908.63 2293.55 2240.6 2657.44 2238.56 2658.38 1863.19"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1803.57 2500.86 1767.29 2472.95 922 2358 893 2360 897 2471 919 2507 954 2507 954 2475 983.76 2507.68 988.76 2611.67 1017.94 2659.44 1013.88 2506.44 1281.62 2560.4 1340.36 2657.12 1463.67 2539.62 1619.41 2560.26 1697.68 2659.44 1803.57 2500.86"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "caisson-2",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1016.66 2658.08 1013.05 2505.09 1803.75 2501.2 1798.68 2658.08 1696.76 2658.08 1699.29 2558.25 1475.82 2559.55 1475.82 2658.08 1340.35 2658.08 1335.91 2558.9 1111.81 2558.9 1113.08 2658.08 1016.66 2658.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1148.74,
    y: 2515.58,
    width: 40.78,
    height: 15.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1290.85,
    y: 2515.58,
    width: 40.78,
    height: 15.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1477.45,
    y: 2515.58,
    width: 40.78,
    height: 15.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1619.57,
    y: 2515.58,
    width: 40.78,
    height: 15.82
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1008.65 2499.66 922 2392.81 937.28 1526.96 923.83 1453.64 919 1326.09 1236.68 1325.95 1357.99 1335.65 1362.25 1453.64 1468.66 1453.64 1780.44 1526.12 1789.01 2490.52 1008.65 2499.66"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1008.86 2500.08 1001.93 1541.58 980.57 1527.38 980.57 1340.57 922 1332.09 922.21 2393.23 1008.86 2500.08"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1397.59,2494.11h7.1V2306.75l-3.55-7.11V2117.46l-2.41-6.4,2.41-186.45,382.8-5.08,0-5.65-379.82,2.61.6-187.68,369.34-4s3-5.46,1.49-6-373.81,3.47-373.81,3.47V1531.23l-32.27-10v6l27.8,14.89-1,184.18-393.13,5v6l394.12-2-1,184.67-391.72,6.46h389v184.67l2.71,7.95-2.71,185.16,4.7,5Z",
    transform: "translate(0 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M929.38,1681.21c13.67,7.64,73.7,47.81,73.7,47.81l0,8.23-73.72-49.76Z",
    transform: "translate(0 1)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1004.49 1923.82 926.49 1866.29 926.49 1871.4 1004.51 1927.39 1004.49 1923.82"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1005.87 2114.97 924.9 2052.13 924.9 2057.31 1005.9 2119.35 1005.87 2114.97"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1393.52 2112.05 1005.87 2114.97 1005.9 2119.35 1396.23 2120 1393.52 2112.05"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "1401.14 2118.46 1398.73 2112.06 1785.6 2106.8 1785.64 2112.05 1401.14 2118.46"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "1404.69 2307.75 1787.32 2300.72 1785.64 2295.67 1401.14 2300.64 1404.69 2307.75"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "1393.52 2301.71 1007.23 2304.09 1007.26 2307.75 1396.23 2307.75 1393.52 2301.71"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "980.36 1526.96 1363.03 1524.29 1369.42 1528.26 1369.42 1522.25 1363.14 1519.35 980.36 1526.19 980.36 1526.96"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1780.44 1526.12 1401.69 1532.23 1363.14 1519.35 1362.25 1453.64 1467.75 1453.39 1780.44 1526.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationCarton);
export default __webpack_public_path__ + "static/media/situation_carton.0edcd7767e29f10dec0b68af976c7961.svg";
export { ForwardRef as ReactComponent };